import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { twilioErrorLogsStateForMessageSidSelector } from '../twilio-error-log-selectors';

import { get } from '../../api/api';

export const loadTwilioErrorLogs = (messageSid: string) =>
  createGenericDispatcher<Array<TwilioErrorLog>>({
    name: 'LOAD_TWILIO_ERROR_LOGS',
    loadFunction: () => get(`/twilio-error-log?messageSid=${messageSid}`),
    args: { messageSid },
    shouldExecuteSelector: (state: any) =>
      twilioErrorLogsStateForMessageSidSelector(state, messageSid),
  });
